<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">{{ toBeUpdated() ? "Edit" : "Add" }} Field</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <form class="modal-body" [formGroup]="form" (ngSubmit)="onSubmit()" aria-describedby="required-fields-note">
    <div class="modal-body-inner">
      <div class="required-fields-explanation" role="note" tabindex="-1" id="required-fields-note">
        <p><span class="text-danger" aria-hidden="true">*</span> Indicates required fields</p>
      </div>
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <app-input
              controlName="Name"
              [form]="form"
              label="Field Name"
              [matchMessage]="matchMessage"
              [labelHelper]="
                isUrl() && isFormulaSelected() ? urlFieldNameLabelHelper : ''
              "
              [disabled]="isRelationSelected() || isLookupField()"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12" *ngIf="!isRelationSelected() && !form.value.LookupTargetFieldKey">
            <app-select
              [form]="form"
              controlName="FieldType"
              label="Field Type"
              [options]="fieldTypes"
              (selected)="fieldSelectReceiver($event)"
              [disabled]="toBeUpdated()"
              [toShowRedAsteriskWhenDisabled]="true"
              [isLoading]="isFieldTypesLoading.isLoading"
              [isError]="isFieldTypesLoading.isError"
              ></app-select>
          </div>
          <div class="col-lg-12 col-md-12" *ngIf="form.value.LookupTargetFieldKey">
            <app-input
              controlName="LookupDisplayName"
              [form]="form"
              label="Field Display Name"
              [matchMessage]="matchMessage"
              [labelHelper]="
                isUrl() && isFormulaSelected() ? urlFieldNameLabelHelper : ''
              "
            ></app-input>
          </div>
          <ng-container *ngIf="!form.value.LookupTargetFieldKey">
          <div
            class="col-lg-12 col-md-12"
            *ngIf="isENUMSelected()"
          >
            <app-checkbox
              [form]="form"
              label="Display List in Alphabetical Order"
              controlName="IsAlphaSort"
            ></app-checkbox>
          </div>
          <ng-container *ngIf="isENUMSelected()">
            <app-selector-dropdown-values
              class="w-100"
              [valueControl]="valueControl"
              (valueAdded)="addValue()"
              (valueRemoved)="removeValue($event)"
              (valuesReordered)="rowDrop($event)"
            ></app-selector-dropdown-values>
          </ng-container>
          <ng-container *ngIf="isFormulaSelected()">
            <div class="col-lg-12 col-md-12">
              <div class="monaco-editor">
                <ngx-monaco-editor
                  style="height: 100%; width: 100%"
                  [options]="editorOptions"
                  (onInit)="editorInit($event)"
                ></ngx-monaco-editor>
              </div>
              <div class="form-group-control">
                <input
                  type="text"
                  placeholder="Search"
                  class="form-control search-input"
                  (input)="filterOption($event)"
                />
              </div>
              <div class="form-group-control form-select-multiple-group">
                <select multiple class="form-control" name="formulaField">
                  <ng-container *ngFor="let field of filterdOptions">
                    <option
                      [value]="field.value"
                      (dblclick)="addToFormula(field)"
                    >
                      {{ field.label }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <app-checkbox
                [form]="form"
                label="Always Execute On Create Record"
                controlName="AlwaysExecuteOnCreateRecord"
              ></app-checkbox>
            </div>
          </ng-container>
          <ng-container *ngIf="isUrl()">
            <div class="col-lg-12 col-md-12">
              <app-input
                controlName="LinkText"
                [form]="form"
                label="Link Text"
                [labelHelper]="'Leave blank to use URL'"
              >
              </app-input>
            </div>
          </ng-container>
          <ng-container *ngIf="isPIISelected()">
            <div class="col-lg-12 col-md-12" *ngIf="!toBeUpdated()">
              <app-input
                controlName="PIILength"
                [form]="form"
                label="No. of visible characters"
                type="number"
              ></app-input>
            </div>
            <div class="col-lg-12 col-md-12" *ngIf="!toBeUpdated()">
              <div class="form-group radio-form-group center-radio-form-group">
                <label for="PIIDirection" class="control-label"
                  >Display from</label
                >
                <div class="form-group radio-form-group">
                  <div class="custom-radio-root">
                    <app-radio
                      [form]="form"
                      value="LTR"
                      controlName="PIIDirection"
                      label="Left"
                    ></app-radio>
                    <app-radio
                      [form]="form"
                      value="RTL"
                      controlName="PIIDirection"
                      label="Right"
                    ></app-radio>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12" *ngIf="form.controls.FieldType.value === 'Encrypted (Standard)'">
              <app-select
                controlName="FieldRoles"
                [form]="form"
                [options]="applicationRoles"
                [multiple]="true"
                [value]="form.controls.FieldRoles.value"
                label="Roles with Decrypt Rights"
                [isLoading]="isApplicationRolesLoading[applicationKey]"
                [isError]="isApplicationRolesLoading['error-'+applicationKey]"
              ></app-select>
            </div>
          </ng-container>
          <div class="col-lg-12 col-md-12" *ngIf="isUrl()">
            <app-checkbox
              [form]="form"
              label="Is External Link"
              controlName="IsExternalUrl"
            ></app-checkbox>
          </div>
          <div
            class="col-lg-12 col-md-12"
            *ngIf="!isRelationSelected() && !isUniqueNotAllowed() && !isUuidSelected()"
          >
            <app-checkbox
              [form]="form"
              label="Must be Unique"
              controlName="IsUnique"
              [disabled]="isUnique"
            ></app-checkbox>
          </div>
          <div class="col-lg-12 col-md-12" *ngIf="!isNullableNotAllowed() && !isUuidSelected()">
            <app-checkbox
              [form]="form"
              label="Allow Null(blank) Values"
              controlName="IsNullable"
              [disabled]="isNullable"
            ></app-checkbox>
          </div>
          <div
            class="col-lg-12 col-md-12"
            *ngIf="isENUMSelected() || isRelationSelected()"
          >
            <app-checkbox
              [form]="form"
              label="Allow additions on Form Edit"
              controlName="IsFlyAdditionAllowed"
            ></app-checkbox>
          </div>
          <div class="col-lg-12 col-md-12" *ngIf="this.form.controls.FieldType.value == 'Text'">
            <app-input
              [form]="form"
              controlName="FieldSize"
              label="Field Size"
              type="number"
              [disabled]="toBeUpdated()"
            ></app-input>
          </div>
          <div
            *ngIf="
              this.form.value.IsFormula &&
              this.form.controls.FieldType.value == 'Formula - Text'
            "
            style="display: flex; flex-direction: row"
            class="col-lg-12 col-md-12"
          >
            <app-checkbox
              [form]="form"
              label="Allow HTML"
              controlName="IsHtmlAllowed"
            >
            </app-checkbox>
            <i class="icon-info" [title]="getHTMLTags()"></i>
          </div>
          <ng-container *ngIf="isNumericOrCurrencySelected()">
            <div class="col-lg-12 col-md-12">
              <app-checkbox
                [form]="form"
                label="Display a summary of this field in report grouping"
                controlName="isGroupSummaryType"
              ></app-checkbox>
            </div>
            <div
              *ngIf="this.form.value.isGroupSummaryType"
              class="col-lg-12 col-md-12"
            >
              <app-select
                [form]="form"
                controlName="onGroupingSummaryType"
                label="Grouping Summary Type"
                [options]="groupSummaryType"
              ></app-select>
            </div>
          </ng-container>
          <ng-container *ngIf="isFileSelected() || isFile">
            <div class="col-lg-6 col-md-6">
              <app-checkbox
                [form]="form"
                type="toggle"
                class="field-toogle-checkbox"
                label="Enable Document Creation"
                controlName="EnableDoc"
              ></app-checkbox>
            </div>
          </ng-container>
          </ng-container>
          <div class="col-lg-12 col-md-12" *ngIf="!form.value.LookupTargetFieldKey"> 
            <app-textarea
              controlName="Info"
              [form]="form"
              [label]="'Info Text for Form Display'"
              ></app-textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <div class="modal-footer-bottom-row">
        <app-button
          [style]="'secondary'"
          title="Cancel"
          (onClick)="close()"
          class="mr-2"
        ></app-button>
        <app-button
          type="submit"
          [disabled]="form.invalid || invalidSyntax"
          [title]="toBeUpdated() ? 'Update' : 'Add'"
        ></app-button>
      </div>
    </div>
  </form>
</div>
